import { Navigate, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button/Button';
import { Icon } from '@/components/ui/Icon/Icon';
import { useSession } from '@/services/auth';
import { EDITABLE_DOCUMENTS } from '@/services/documents';
import { nb } from '@/i18n/nb';
import s from '../admin.module.css';

// Admin-only document list (Innhold). The sidebar hides this from owners; this guard
// covers a direct URL hit, and the server enforces admin-only on the PATCH regardless.
export function AdminContent() {
  const navigate = useNavigate();
  const { user, isLoading } = useSession();

  if (isLoading) return null;
  if (user?.role !== 'admin') return <Navigate to="/" replace />;

  return (
    <div>
      <div className={s.head}>
        <div>
          <h2 className={s.title}>{nb.admin.content.title}</h2>
          <p className={s.lede}>{nb.admin.content.lede}</p>
        </div>
      </div>

      <div className={s.cards}>
        {EDITABLE_DOCUMENTS.map((doc) => (
          <div key={doc.slug} className={s.reqCard}>
            <div className={s.reqInfo}>
              <b>{doc.title}</b>
              <span className={s.cellMuted}>/admin/innhold/{doc.slug}</span>
            </div>
            <div className={s.reqActs}>
              <Button
                variant="primary"
                onClick={() => navigate(`/admin/innhold/${doc.slug}`, { state: { from: 'innhold' } })}
              >
                <Icon name="pencil" size={16} /> {nb.admin.content.edit}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
